import React from 'react';
import DeliverabilityHub from '@/components/app/DeliverabilityHub/DeliverabilityHub';

export default function DeliverabilityHubPage() {
  return <DeliverabilityHub />;
}
